import type { Amount } from '@shared/core-types';

import { alignAmountsPrecision } from './alignAmountsPrecision';

type Transform = (n: number) => number;
const IDENTITY: Transform = (n) => n;

export const isEqualAmount = (amounts: Amount[], transform: Transform = IDENTITY): boolean => {
    const [referenceAmount, ...testAmounts] = alignAmountsPrecision(amounts);
    const referenceValue = transform(referenceAmount?.value);
    return testAmounts.every(
        ({ currency, value }) =>
            currency === referenceAmount.currency && transform(value) === referenceValue,
    );
};
